import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PagesComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PagesSettingsPage" */ "@circle-react/components/SettingsApp/Site/Pages"
    ),
);

export const Pages = () => (
  <Suspense fallback={<PageLoader />}>
    <PagesComponent />
  </Suspense>
);
